import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setEmotionally, setNewEmotionally } from "../../slices/riskSlice";

const TableCellEmotionallyNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [emotionally2, setStateEmotionally2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdemotionally, setCheckedIdemotionally] = useState("");

	const [addEmotionally2, setAddEmotionally2] = useState(false);
    const [emotionally, setStateEmotionally] = useState([]);
    const [emotionallyArray, setStateEmotionallyArray] = useState([]);
    
    const [emotionallyArrayUl, setStateEmotionallyArrayUl] = useState([]);

    return (
        <>
            {emotionallyArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(emotionallyArrayUl)
                                    emotionallyArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewEmotionally([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStateEmotionallyArrayUl(emotionallyArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStateEmotionallyArray([...emotionallyArray, true]); setStateEmotionallyArrayUl([...emotionallyArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellEmotionallyNew;